import * as ApiDetails from './api';
import * as ParseDetails from './parser';
import * as config from './config';


export default { ...ApiDetails, ...ParseDetails, ...config };
